import { useState, useEffect } from 'react';
import axios from 'axios';
import { FileCheck, FileText, Award, ScrollText, Eye, Download, Trash2, Upload } from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;

export const DOC_TYPES = [
  // === Documents contractuels signés ===
  { value: 'attestation_signee', label: 'Attestation signée', category: 'Contractuel', color: 'bg-blue-100 text-blue-700 border-blue-300', icon: FileCheck },
  { value: 'conditions_generales_particulieres_signees', label: 'Conditions générales & particulières signées', category: 'Contractuel', color: 'bg-emerald-100 text-emerald-700 border-emerald-300', icon: FileText },
  { value: 'attestation_ftpe_signee', label: 'Attestation FTPE signée', category: 'Contractuel', color: 'bg-amber-100 text-amber-700 border-amber-300', icon: Award },
  { value: 'devis_ess', label: 'Devis ESS', category: 'Contractuel', color: 'bg-violet-100 text-violet-700 border-violet-300', icon: ScrollText },
  { value: 'proposition_signee_manuscrite', label: 'Proposition ESS signée (manuscrite)', category: 'Contractuel', color: 'bg-violet-100 text-violet-700 border-violet-300', icon: ScrollText },

  // === Justificatifs de paiement RCDS ===
  { value: 'justificatif_paiement_rcds_batico', label: 'Justificatif paiement RCDS BATICO', category: 'Paiement RCDS', color: 'bg-teal-100 text-teal-700 border-teal-300', icon: FileCheck },
  { value: 'justificatif_paiement_rcds_avenant', label: 'Justificatif paiement RCDS Avenant', category: 'Paiement RCDS', color: 'bg-teal-100 text-teal-700 border-teal-300', icon: FileCheck },
  { value: 'justificatif_paiement_rcds_archos', label: 'Justificatif paiement RCDS ARCHOS', category: 'Paiement RCDS', color: 'bg-teal-100 text-teal-700 border-teal-300', icon: FileCheck },
  { value: 'justificatif_paiement_rcds_nominative', label: 'Justificatif paiement RCDS Nominative', category: 'Paiement RCDS', color: 'bg-teal-100 text-teal-700 border-teal-300', icon: FileCheck },

  // === Justificatifs de paiement DOS DOMIUM ===
  { value: 'justificatif_paiement_dos_domium', label: 'Justificatif paiement DOS DOMIUM', category: 'Paiement DOMIUM', color: 'bg-cyan-100 text-cyan-700 border-cyan-300', icon: FileCheck },

  // === Pièces société / juridique ===
  { value: 'kbis', label: 'KBIS / Extrait Kbis', category: 'Pièces société', color: 'bg-slate-100 text-slate-700 border-slate-300', icon: FileText },
  { value: 'piece_identite', label: 'Pièce d\'identité', category: 'Pièces société', color: 'bg-slate-100 text-slate-700 border-slate-300', icon: FileText },
  { value: 'fiche_insee', label: 'Fiche INSEE', category: 'Pièces société', color: 'bg-slate-100 text-slate-700 border-slate-300', icon: FileText },
  { value: 'fiche_inpi', label: 'Fiche INPI', category: 'Pièces société', color: 'bg-slate-100 text-slate-700 border-slate-300', icon: FileText },
  { value: 'liasse_fiscale', label: 'Liasse fiscale', category: 'Pièces société', color: 'bg-slate-100 text-slate-700 border-slate-300', icon: FileText },
  { value: 'bilan', label: 'Bilan comptable', category: 'Pièces société', color: 'bg-slate-100 text-slate-700 border-slate-300', icon: FileText },
  { value: 'rib', label: 'RIB', category: 'Pièces société', color: 'bg-indigo-100 text-indigo-700 border-indigo-300', icon: FileText },
  { value: 'mandat_sepa_signe', label: 'Mandat SEPA signé', category: 'Pièces société', color: 'bg-indigo-100 text-indigo-700 border-indigo-300', icon: FileCheck },

  // === Pièces techniques & chantier ===
  { value: 'plan_architecte', label: 'Plans Architecte', category: 'Technique & chantier', color: 'bg-orange-100 text-orange-700 border-orange-300', icon: FileText },
  { value: 'permis_construire', label: 'Permis de construire', category: 'Technique & chantier', color: 'bg-orange-100 text-orange-700 border-orange-300', icon: FileText },
  { value: 'devis_travaux', label: 'Devis travaux', category: 'Technique & chantier', color: 'bg-orange-100 text-orange-700 border-orange-300', icon: ScrollText },
  { value: 'doc', label: 'DOC (Déclaration d\'Ouverture de Chantier)', category: 'Technique & chantier', color: 'bg-orange-100 text-orange-700 border-orange-300', icon: FileText },
  { value: 'pv_reception', label: 'PV de réception', category: 'Technique & chantier', color: 'bg-orange-100 text-orange-700 border-orange-300', icon: FileCheck },
  { value: 'daact', label: 'DAACT (Déclaration d\'Achèvement et Conformité)', category: 'Technique & chantier', color: 'bg-orange-100 text-orange-700 border-orange-300', icon: FileCheck },

  // === Financement ===
  { value: 'accord_financement', label: 'Accord de financement', category: 'Financement', color: 'bg-pink-100 text-pink-700 border-pink-300', icon: FileCheck },

  // === Autre ===
  { value: 'autre_document', label: 'Autre document', category: 'Autre', color: 'bg-gray-100 text-gray-700 border-gray-300', icon: FileText },
];

// Hook pour récupérer les types de documents personnalisés (créés par le super admin).
// Les types perso sont fusionnés avec DOC_TYPES dans la liste affichée.
export const useCustomDocumentTypes = (token) => {
  const [customTypes, setCustomTypes] = useState([]);
  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/api/admin/ged/document-types`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!cancelled) {
          // Mapper en format DOC_TYPES (sans icône native — utilise un fallback FileText)
          const mapped = (res.data || []).map((t) => ({
            value: t.value,
            label: t.label,
            category: t.category || 'Personnalisé',
            color: t.color || 'bg-purple-100 text-purple-700 border-purple-300',
            icon: FileText,
            isCustom: true,
            // Rubrique d'éligibilité BATICO liée (optionnelle).
            // Permet au simulateur de détecter automatiquement les
            // justificatifs uploadés via les types personnalisés.
            eligibility_rubrique: t.eligibility_rubrique || null,
          }));
          setCustomTypes(mapped);
        }
      } catch (err) {
        // Endpoint optionnel — silencieux si 404 ou pas implémenté
        if (!cancelled) setCustomTypes([]);
      }
    })();
    return () => { cancelled = true; };
  }, [token]);
  return customTypes;
};

export const CUSTOM_TYPE_COLORS = ['blue', 'emerald', 'amber', 'violet', 'teal', 'cyan', 'slate', 'indigo', 'orange', 'pink', 'purple', 'rose', 'sky'];

// Catégories natives (built-in) extraites de DOC_TYPES — ordre stable
export const BUILTIN_CATEGORIES = [
  'Contractuel',
  'Paiement RCDS',
  'Paiement DOMIUM',
  'Pièces société',
  'Technique & chantier',
  'Financement',
  'Autre',
  'Personnalisé',
];

export const AUDIT_ACTION_CONFIG = {
  view:       { label: 'Consultation', color: 'text-blue-700 bg-blue-50 border-blue-200', icon: Eye },
  download:   { label: 'Téléchargement', color: 'text-emerald-700 bg-emerald-50 border-emerald-200', icon: Download },
  print:      { label: 'Impression', color: 'text-purple-700 bg-purple-50 border-purple-200', icon: FileText },
  zip_export: { label: 'Export ZIP', color: 'text-teal-700 bg-teal-50 border-teal-200', icon: Download },
  delete:     { label: 'Suppression', color: 'text-red-700 bg-red-50 border-red-200', icon: Trash2 },
  upload:     { label: 'Téléversement', color: 'text-amber-700 bg-amber-50 border-amber-200', icon: Upload },
};

export const formatAuditTimestamp = (iso) => {
  if (!iso) return '-';
  try {
    const dt = new Date(iso);
    return dt.toLocaleString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  } catch { return iso; }
};
